import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Can, hasPermission} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import {Button, Checkbox, Input} from "antd";
import RenderLoading from "@/components/render-if-loading";
import RenderIf from "@/components/render-if";
import {PermCard} from "@/pages/admin/roles/[id]/_section/PermCard";
import {permissionModuleEnum} from "@/lib/helper/enumType";
import {
    useApiDeleteAdminRole,
    useApiReadAdminRole,
    useApiSearchAdminPermissions,
    useApiUpdateAdminRole,
    useApiUpdateAdminRolePermissions
} from "@/api/roles";

export function AdminRolesEditPage() {
    const navigate = useNavigate()
    const {id} = useParams();

    const [canDeleteRole, setCanDeleteRole] = useState(false)

    const {data: roleData, isPending: isPendingRoleData} = useApiReadAdminRole(id)
    const {data: allPermissions, isPending: isPendingAllPermissions} = useApiSearchAdminPermissions()
    const {mutate: putPermission, isPending: isPendingPutPermission} = useApiUpdateAdminRolePermissions()
    const {mutate: putRole, isPending: isPendingPutRole} = useApiUpdateAdminRole()
    const {mutate: deleteRole} = useApiDeleteAdminRole()
    const [newPermission, setNewPermission] = useState([])
    const [allMyPermissions, setAllMyPermissions] = useState([])
    const [allPermissionsGroup, setAllPermissionsGroup] = useState([])
    const [roleName, setRoleName] = useState('')


    const canEdit = hasPermission(PermList.ROLES_EDIT)

    useEffect(() => {

        let myPerm = {}

        allPermissions?.data?.data?.map((item) => {
            if (!myPerm[item.module]) {
                myPerm[item.module] = []
            }
            myPerm[item.module].push(item)
        })

        let myKey = Object.keys(myPerm)
        let myPermArray = []
        myKey.forEach(key => {
            myPermArray.push({module: key, data: myPerm[key]})
        })


        setAllPermissionsGroup(myPermArray)

    }, [allPermissions])

    useEffect(() => {
        let myPerm = {}

        roleData?.data?.data?.permissions?.map((item) => {
            if (!myPerm[item.name]) {
                myPerm[item.name] = []
            }
            myPerm[item.name].push(item)
        })

        let myKey = Object.keys(myPerm)
        let myPermArray = []
        myKey.forEach(key => {
            myPermArray.push(key)
        })
        setAllMyPermissions(myPermArray)
        setNewPermission(myPermArray)

        setRoleName(roleData?.data?.data?.name)

    }, [roleData]);

    const handleChange = (name) => {
        if (newPermission.includes(name)) {
            const myPermission = newPermission.filter((item) => item !== name)
            setNewPermission(myPermission)
        } else {
            setNewPermission([...newPermission, name])
        }
    }

    const handleClick = () => {

        putPermission(
            {
                id: id,
                data: {
                    permissions: newPermission
                }
            },
            {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res)

                },
                onError: (err) => {
                    ApiHandleErrorMessage(err)
                },
            }
        )
        if (roleData?.data?.data?.name !== roleName) {
            putRole(
                {
                    id: id,
                    args: {name: roleName},
                }
            )
        }

    }

    return (
        <AdminLayout pageTitle={'ویرایش سطح دسترسی'} backTo={URLS.admin.roles.dashboard}>

            <div className={'px-4 py-2'}>
                <div className={`w-full relative rounded shadow-sm p-4 flex flex-col gap-3`}>
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            <Input
                                readOnly={!hasPermission(PermList.ROLES_EDIT)}
                                disable={!hasPermission(PermList.ROLES_EDIT)}
                                value={roleName}
                                onChange={(e) => setRoleName(e.target.value)}
                                disabled={isPendingRoleData || isPendingPutRole}
                            />
                        </div>
                        <div className={'p-2 rounded'}>
                            <Can permission={PermList.ROLES_EDIT}>
                                <Button
                                    disabled={isPendingPutPermission || isPendingPutRole}
                                    loading={isPendingPutPermission || isPendingPutRole}
                                    onClick={() => handleClick()}
                                    type={`primary`}>ذخیره</Button>
                            </Can>
                        </div>
                    </div>
                </div>

                <RenderLoading loading={isPendingRoleData || isPendingAllPermissions}>

                    <RenderIf condition={allPermissionsGroup?.length > 0}>

                        {allPermissionsGroup.map((item, index) => {
                            return (
                                <PermCard
                                    canEdit={canEdit}
                                    role={permissionModuleEnum(item?.module)}
                                    color={permissionModuleEnum(item?.module, 'color')}
                                    item={item}

                                    allMyPermissions={allMyPermissions}
                                    newPermission={newPermission}
                                    handleChange={handleChange}
                                    setNewPermission={setNewPermission}
                                >

                                </PermCard>)
                        })}
                        <Can permission={PermList.ROLES_DELETE}>
                            <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center gap-2">
                                        <i className={`icon-trash-can text-red-6`}></i>
                                        <span className={`text-lg`}>حذف سطح دسترسی</span>
                                        <Checkbox
                                            checked={canDeleteRole}
                                            onChange={(e) => setCanDeleteRole(e.target.checked)}>
                                            آیا از حذف این سطح دسترسی اطمینان دارید
                                        </Checkbox>
                                    </div>

                                    {canDeleteRole &&
                                        <Button
                                            onClick={() => deleteRole(
                                                {
                                                    id: id,
                                                }, {
                                                    onSuccess: (res) => {
                                                        navigate(URLS.admin.roles.dashboard)
                                                    },
                                                    onError: (err) => {
                                                        ApiHandleErrorMessage(err)
                                                    }
                                                }
                                            )}
                                            type={`primary`} danger>حذف سطح دسترسی</Button>
                                    }
                                </div>


                            </div>
                        </Can>
                    </RenderIf>
                </RenderLoading>


            </div>


        </AdminLayout>
    )
}
